// extracted by mini-css-extract-plugin
module.exports = {"base":"useModalProjectDelete_base__11rXy","label":"useModalProjectDelete_label__kvT_1"};